import * as yup from 'yup';

export const initialValues = {
  birthdate: '',
  gender: '',
  genderOther: '',
  cnhHas: null,
  cnhType: '',
};

function validateCNH(cnh) {
  if (cnh == null || cnh === '') { return true };
  var char1 = cnh.charAt(0);

  if (cnh.replace(/[^\d]/g, '').length !== 11 || char1.repeat(11) === cnh) {
    return false;
  }

  for (var i = 0, j = 9, v = 0; i < 9; ++i, --j) {
    v += +(cnh.charAt(i) * j);
  }

  var dsc = 0,
    vl1 = v % 11;

  if (vl1 >= 10) {
    vl1 = 0;
    dsc = 2;
  }

  for (i = 0, j = 1, v = 0; i < 9; ++i, ++j) {
    v += +(cnh.charAt(i) * j);
  }

  var x = v % 11;
  var vl2 = x >= 10 ? 0 : x - dsc;

  return '' + vl1 + vl2 === cnh.substr(-2);
}


const schema = yup.object().shape({
  birthdate: yup
    .string()
    .matches(
      /([0-9]{2}\/[0-9]{2}\/[0-9]{4})/,
      { message: 'Data de nascimento é obrigatória!', excludeEmptyString: true })
    .required('Data de nascimento é obrigatória!')
    .test('is-old-enough', 'Você deve ter pelo menos 16 anos de idade.', function (value) {
      if (!value) return true; // Skip validation if the value is empty
      const birthdate = new Date(value.split('/').reverse().join('-'));
      const cutoffDate = new Date();
      cutoffDate.setFullYear(cutoffDate.getFullYear() - 16);
      return birthdate <= cutoffDate;
    }),
  gender: yup.string().required('Gênero é obrigatório!'),
  genderOther: yup.string(),
  cnhHas: yup.boolean().typeError('É obrigatório responder se tem CNH!').required('É obrigatório responder se tem CNH!'),
  cnhType: yup.string(),
});

export default schema;
